import { Spinner } from '@frontend/components/common';
import { CommonMessage } from '@frontend/lang';
import { createPortal } from 'react-dom';
import { LuX } from 'react-icons/lu';

import useLoadingModal from './loading-modal.controller';

const ID = 'loading-modal';
export interface LoadingModalProps {
    show?: boolean;
    message?: string | React.ReactNode;
    onClose?: () => void;
}

const LoadingModal = (props: LoadingModalProps) => {
    const viewProps = useLoadingModal(props);

    if (!props.show) {
        return null;
    }

    const root = document.getElementById('root');
    if (!root) return null;

    return createPortal(
        <div
            id={ID}
            className='fixed inset-0 z-1000 flex items-center justify-center'
            data-node-id='3428:4379'>
            {/* Backdrop */}
            <div
                className='absolute inset-0 bg-stone-950/40'
                data-name='Background'
                data-node-id='3428:4406'
            />

            {/* Modal */}
            <div
                className='bg-background-surface border-border-default relative z-10 flex w-96 flex-col items-center justify-center gap-6 overflow-hidden rounded-2xl border p-6'
                data-name='Modal'
                data-node-id='3428:4407'>
                {/* Modal Header */}
                <div className='flex w-full flex-col items-start gap-0 self-stretch'>
                    <div className='flex h-6 w-full items-start justify-between self-stretch'>
                        <p className='text-foreground-default text-xl font-semibold'>{CommonMessage.FORMS.LOADING_PLACEHOLDER}</p>
                        <button
                            disabled={!props.onClose}
                            className='text-foreground-default disabled:text-brand-disabled relative flex size-6 cursor-pointer items-center justify-center overflow-hidden transition-colors'
                            onClick={() => props.onClose && props.onClose()}
                            data-name='Icon Container'
                            data-node-id='3428:4411'>
                            <LuX className='size-full' />
                        </button>
                    </div>
                </div>

                {/* Spinner */}
                <div
                    className='relative size-16 shrink-0'
                    data-node-id='3428:10582'>
                    <Spinner className='fill-brand-primary text-border-default size-full' />
                </div>

                {/* Message */}
                {props.message && <p className='text-foreground-default min-w-full text-center text-base font-medium whitespace-pre-wrap'>{props.message}</p>}
            </div>
        </div>,
        root
    );
};

export default LoadingModal;
